import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { map, skipWhile, switchMap, take } from 'rxjs/operators';

import { AuthService } from 'src/app/modules/core/services/auth.service';

import { YourHomeFacade } from 'src/app/modules/ngrx-store/your-home/your-home.facade';

/**
 * Allows the Contact Information route only when the API reports the feature as enabled for the home's market.
 * The global and market feature flag logic is evaluated by the API; the client only reads the result.
 * Returning false falls through to the default error page.
 */
export const contactInformationGuard: CanMatchFn = () => {
	const yourHomeFacade = inject(YourHomeFacade);
	const authService = inject(AuthService);

	return authService.canActivate().pipe(
		skipWhile(canActivate => !canActivate), // Wait until authenticated
		take(1),
		switchMap(() => yourHomeFacade.homeDetails$),
		skipWhile(homeDetails => !homeDetails), // Wait until homeDetails is defined
		take(1),
		map(homeDetails => !!homeDetails?.contactInformationEnabled)
	);
};
